import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, FileSpreadsheet, Eye, EyeOff } from "lucide-react";
import api, { formatError } from "@/lib/api";

export default function YoungGrades() {
  const [grades, setGrades] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/admin/grades").then(({ data }) => setGrades(data.grades)).catch(() => setGrades([]));
  useEffect(() => { load(); }, []);
  const toggle = async (g) => {
    if (!window.confirm(g.live ? `Hide Grade ${g.grade} from parents again?` : `Make Grade ${g.grade} visible to all parents now?`)) return;
    setBusy(`live${g.grade}`);
    try { await api.post(`/admin/grades/${g.grade}/live`, { live: !g.live }); toast.success(`Grade ${g.grade} ${g.live ? "hidden" : "is now live"}`); load(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail) || e.message); } finally { setBusy(""); }
  };
  const download = async (g) => {
    setBusy(`x${g}`);
    try {
      const { data } = await api.get(`/admin/grades/${g}/export`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      Object.assign(document.createElement("a"), { href: url, download: `anou-appran-grade${g}-questions-review.xlsx` }).click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Could not download the Excel file."); } finally { setBusy(""); }
  };
  if (!grades) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 mt-3 text-sm" data-testid="admin-young-grades">
      <span className="text-slate-400">Grades 1–3:</span>
      {grades.map((g) => (
        <div key={g.grade} className="inline-flex items-center gap-1.5 rounded-full border-2 border-slate-600 pl-3 pr-1 py-0.5" data-testid={`admin-young-${g.grade}`}>
          <b>G{g.grade}</b>
          <span className="text-slate-400 text-xs">{g.questions ? `${g.questions} Qs · ${g.subjects.length} subjects` : "no questions yet"}</span>
          <span className={`text-xs font-bold ${g.live ? "text-green-300" : "text-amber-300"}`} data-testid={`admin-young-status-${g.grade}`}>{g.live ? "LIVE" : "hidden"}</span>
          {g.questions > 0 && (
            <>
              <button onClick={() => download(g.grade)} disabled={!!busy} title="Download for review" data-testid={`admin-young-export-${g.grade}`} className="p-1.5 rounded-full hover:bg-slate-700">
                {busy === `x${g.grade}` ? <Loader2 size={13} className="animate-spin" /> : <FileSpreadsheet size={14} className="text-emerald-300" />}
              </button>
              <button onClick={() => toggle(g)} disabled={!!busy} data-testid={`admin-young-toggle-${g.grade}`}
                className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${g.live ? "bg-slate-700" : "bg-green-600"}`}>
                {g.live ? <><EyeOff size={12} /> Hide</> : <><Eye size={12} /> Go live</>}
              </button>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
